<template>
  <div class="datepicker-min-max-controls pt-2 pb-0 mt-1 position-relative w-100">
    <b-button
      variant="transparent"
      class="d-flex align-items-center btn-link reset-button"
      :class="{ 'f-14': hasMobileSize, 'ml-auto': !isBeginsAt }"
      data-cy="set-date-to-min-max"
      @click="handleClick"
    >
      <span v-if="!isBeginsAt" data-cy="set-time-til-end">{{ $t('ui.date_time_picker.til_end') }}</span>
      <sdui-icon class="icon-arrow-end-o icon-28 ml-1 d-block" :class="{ 'icon-rotate-180': isBeginsAt }" />
      <span v-if="isBeginsAt" data-cy="set-time-before-begin">{{ $t('ui.date_time_picker.before_begin') }}</span>
    </b-button>
  </div>
</template>

<script>
import isMobileDeviceMixing from 'src/mixins/miscellaneous/isMobileDeviceMixin.js'

export default {
  // TODO VUE3: Remove compatConfig when @vue/compat is removed
  compatConfig: {
    COMPONENT_V_MODEL: false,
  },

  name: 'SMinMaxDateControl',
  mixins: [isMobileDeviceMixing],
  props: {
    modelValue: {
      type: String,
      default: '',
    },

    isBeginsAt: {
      type: Boolean,
      default: true,
    },

    dateToSet: {
      type: String,
      required: true,
    },
  },

  emits: ['update:modelValue'],

  methods: {
    handleClick() {
      this.$emit('update:modelValue', this.dateToSet)
    },
  },
}
</script>

<style scoped lang="scss">
.datepicker-min-max-controls {
  border-top: 1px solid $color-gray-100;
}

.ml-auto {
  margin-left: auto;
}
</style>
